import { CharacterSaveRhetoric, CharacterUpdateRhetoric, CharacterAdjustRhetoric, CharacterOverrideRhetoric } from "../actions/CharacterRhetoricActions";
import { CharacterState } from "../CharacterStore.State";
import { CharacterReducerHelpers } from "./CharacterReducerHelpers";

const saveRhetoric = (state: CharacterState, action: CharacterSaveRhetoric): CharacterState => {
    const { character, rhetoricId } = action;
    const newCharacter = { ...character };
    const rhetoric = newCharacter.rhetorics.find(r => r.id == rhetoricId);
    if (rhetoric == null) {
        console.error('Attempt to save nonexistent rhetoric.');
        return state;
    }

    delete newCharacter.pendingProperties[rhetoric.instanceId];

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

const updateRhetoric = (state: CharacterState, action: CharacterUpdateRhetoric): CharacterState => {
    const { character, rhetoricId, priority } = action;
    const rhetoric = character.rhetorics.find(r => r.id == rhetoricId);
    if (rhetoric == null) {
        console.error('Attempt update nonexistent rhetoric.');
        return state;
    }

    const newCharacter = {
        ...character,
        rhetorics: [...character.rhetorics.filter(r => r.id != rhetoricId), { ...rhetoric, priority }]
    };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

const adjustRhetoric = (state: CharacterState, action: CharacterAdjustRhetoric): CharacterState => {
    const { character, rhetoricId, adjustment } = action;
    
    const rhetoric = character.rhetorics.find(r => r.id == rhetoricId);
    if (rhetoric == null) {
        console.error('Attempt adjust nonexistent rhetoric.');
        return state;
    }

    const newCharacter = {
        ...character,
        rhetorics: [...character.rhetorics.filter(r => r.id != rhetoricId), { ...rhetoric, adjustment }]
    };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

const overrideRhetoric = (state: CharacterState, action: CharacterOverrideRhetoric): CharacterState => {
    const { character, rhetoricId, override } = action;

    const rhetoric = character.rhetorics.find(r => r.id == rhetoricId);
    if (rhetoric == null) {
        console.error('Attempt override nonexistent rhetoric.');
        return state;
    }

    const newCharacter = {
        ...character,
        rhetorics: [...character.rhetorics.filter(r => r.id != rhetoricId), { ...rhetoric, override }]
    };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

export const CharacterRhetoricReducers = {
    saveRhetoric,
    updateRhetoric,
    adjustRhetoric,
    overrideRhetoric,
}